import { frontendURL } from 'dashboard/helper/URLHelper';
import LeadsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/leads'),
      name: 'leads_index',
      component: LeadsIndex,
      meta: { permissions: ['administrator', 'agent'], featureFlag: 'crm' },
    },
  ],
};